import React from 'react';
import './ElectionPage.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'store/store';
import { ICandidate } from 'store/reducers/elections/types';
import Sheet from 'components/redesign/Sheet';
import useIsMobile from 'components/redesign/Sheet/useViewport';
import MorphDialog from 'components/redesign/MorphDialog';
import CandidateTile from 'components/redesign/CandidateTile';
import CandidateDetail from '../candidate/CandidateDetail';

function ElectionPage(): React.ReactElement {
    const { election } = useAppSelector(store => store.electionsStore);
    const { candidateId } = useParams();
    const navigate = useNavigate();
    const { search } = useLocation();
    const isMobile = useIsMobile();

    const candidate = React.useMemo(() => {
        if (!election || !candidateId) return undefined;
        return election.candidates.find(
            item => item.id === Number(candidateId)
        );
    }, [election, candidateId]);
    const [heldCandidate, setHeldCandidate] = React.useState<
        ICandidate | undefined
    >(undefined);
    React.useEffect(() => {
        if (candidate) setHeldCandidate(candidate);
    }, [candidate]);
    const displayCandidate = candidate || heldCandidate;

    const close = React.useCallback(() => {
        if (!election) return;
        navigate(`/elections/${election.id}${search}`);
    }, [election, navigate, search]);

    if (!election) return <span />;

    const open = Boolean(candidate);
    const content = displayCandidate ? (
        <CandidateDetail candidate={displayCandidate} />
    ) : null;
    const ariaLabel = displayCandidate
        ? `${displayCandidate.first_name} ${displayCandidate.last_name}`
        : undefined;

    return (
        <section className="rd-block">
            <h2 className="rd-h2">Кандидаты</h2>
            {election.candidates.length === 0 ? (
                <p className="rd-election-empty">
                    Кандидаты ещё не зарегистрированы
                </p>
            ) : (
                <div className="rd-tiles">
                    {election.candidates.map(item => (
                        <CandidateTile
                            key={item.id}
                            electionId={election.id}
                            data={{
                                id: item.id,
                                firstName: item.first_name,
                                lastName: item.last_name,
                                picture: item.picture,
                                facultyShort: item.group.faculty.name,
                                course: item.course,
                                groupName: item.group.name,
                            }}
                        />
                    ))}
                </div>
            )}

            {isMobile ? (
                <Sheet open={open} onClose={close} ariaLabel={ariaLabel}>
                    {content}
                </Sheet>
            ) : (
                <MorphDialog open={open} onClose={close} ariaLabel={ariaLabel}>
                    {content}
                </MorphDialog>
            )}
        </section>
    );
}

export default React.memo(ElectionPage);
